import React from 'react';
import Tippy from '@tippyjs/react';

import { getCategoriesUrl } from '../../utilities/urlHelper';
import { EVENTS } from '../../utilities/CONSTANTS';
import { canCreateCategory } from '../../utilities/permissionsUtilities';
import getCategoriesAndFolders from '../../api/get-categories';

import CategorySidebarItem from './CategorySidebarItem';
import UncategorizedSidebarItem from './UncategorizedSidebarItem';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';

class SidebarCategoriesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getState();
        this.update = () => this.forceUpdate();
    }

    componentDidMount() { return window.addEventListener(EVENTS.NEW_PAGE_LOADED, this.update); }

    componentWillUnmount() { return window.removeEventListener(EVENTS.NEW_PAGE_LOADED, this.update); }

    getState = () => {
        if (window.categoriesAndFolders && window.categoriesAndFolders.length) {
            return { categories: window.categoriesAndFolders };
        }

        getCategoriesAndFolders()
            .done(({ categories }) => {
                this.setState({ categories });
            });

        return {};
    };

    render() {
        const { categories } = this.state;

        if (categories == null) {
            return (
                <div className="left-nav__section">
                    <div className="left-nav__header ml1">
                        <a className="left-nav__text" href={getCategoriesUrl()}>Categories</a>
                    </div>
                    <div className="ml2 silver h5 loading">Loading categories</div>
                </div>
            );
        }

        return (
            <div className="left-nav__section">
                <div className="left-nav__header ml1">
                    <a className="left-nav__text" href={getCategoriesUrl()}>{`Categories (${categories.length})`}</a>
                    {canCreateCategory()
                        && (
                            <CreateOrEditCategoryWrapper>
                                <Tippy content="create a category" placement="right">
                                    <span id="new-category-button" className="btn btn-small align-baseline show-nav-hover touch-visible">
                                        <img src="/img/icons/insert-plus-icon.svg" height="8px" width="8px" />
                                    </span>
                                </Tippy>
                            </CreateOrEditCategoryWrapper>
                        )}
                </div>
                <div id="header-categories" className="left-nav__categories">
                    {categories.map(category => <CategorySidebarItem key={category.id} category={category} />)}
                    {window.loggedIn && window.showUncategorized && <UncategorizedSidebarItem />}
                </div>
            </div>
        );
    }
}

export default SidebarCategoriesContainer;
